import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  goods: null,
  limit: JSON.parse(localStorage.getItem("pageLimit") as string) || 10,
  offset: 0,
  count: 0,
  pages: 1
};

export const signalsSlice = createSlice({
  name: "goods",
  initialState,
  reducers: {
    reducerGetGoods: (state: Draft<any>, action: PayloadAction<any>) => {
      state.goods = action.payload?.data || null;
      state.count = action.payload?.count || 0;
      state.pages = action.payload?.pages || 1;
    },
    reducerGoodsStatus: (state: Draft<any>, action: PayloadAction<any>) => {
      state.status = action.payload;
    },
  },
});

export const { reducerGetGoods, reducerGoodsStatus } = signalsSlice.actions;

export default signalsSlice.reducer;
